import { Heading } from "../../Shared";
import styles from "./styles.module.css";
import { TableOfContentsType } from "@/types/index";

const TableOfContents: React.FC<{ headings: TableOfContentsType }> = ({
	headings,
}) => {
	const handleClick = (id: string) => {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		}
	};

	return (
		<div className={`${styles.contents_container} mb-5 col w-100`}>
			<div className="col-12 text-center pb-2">
				<Heading title={"Contents"} variant={2} isBold={true} />
			</div>

			<div className="w-100">
				{headings.map((heading, index) => (
					<button
						className={`${styles.content_button} w-100`}
						key={heading.id}
						onClick={() => handleClick(heading.id as string)}
					>
						<span>
							{index + 1}. {heading.text}
						</span>
					</button>
				))}
			</div>
		</div>
	);
};

export default TableOfContents;
